import { z } from "zod";
import { REQUIRED_FIELD } from "../../../utils/constants";

export const AlertSanSchema = z.object({
  name: z.string().min(1, { message: REQUIRED_FIELD }),
  rationalDescription: z.string().min(1, { message: REQUIRED_FIELD }),
  impactDescription: z.string().min(1, { message: REQUIRED_FIELD }),
  frequencyOption: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .nullable()
    .refine((val) => val !== null, { message: REQUIRED_FIELD }),
  indicators: z
    .array(
      z.object({
        indicatorOptions: z
          .object({
            id: z.number(),
            name: z.string(),
          })
          .optional(),
      }),
    )
    .min(1, { message: REQUIRED_FIELD })
    .refine(
      (indicators) =>
        indicators.filter(
          (indicator) => indicator.indicatorOptions?.id !== undefined,
        ).length > 0,
      {
        message: "Selecione pelo menos um indicador",
        path: ["indicators"],
      },
    ),
});
